import { getNumberOfCombinations } from '@superbet-group/web.lib.utilities';

interface SystemParams {
    fromNumber: number;
    minNumber: number;
    isSelected?: boolean;
}

/**
 * Contains information for a single system which user can select, like 1/6.
 *
 * Example: For 1/6
 * @property minNumber is 1
 * @property fromNumber is 6
 */
export default class System {
    public isSelected = false;
    private fromNumber: number;
    private minNumber: number;
    public readonly numberOfCombinations: number;

    constructor(params: SystemParams) {
        this.fromNumber = params.fromNumber;
        this.minNumber = params.minNumber;
        this.numberOfCombinations = this.calculateNumberOfCombinations();
        if (params.isSelected !== undefined) {
            this.isSelected = params.isSelected;
        }
    }

    public getFromNumber(): number {
        return this.fromNumber;
    }

    public getMinNumber(): number {
        return this.minNumber;
    }

    public getNumberOfCombinations() {
        return this.numberOfCombinations;
    }

    public toString() {
        return `${this.minNumber}/${this.fromNumber}`;
    }

    private calculateNumberOfCombinations(): number {
        return getNumberOfCombinations(this.fromNumber, this.minNumber);
    }
}
